module.exports = __webpack_public_path__ + "static/media/low-set(1).f5b122b7.png";